import React from 'react';
import { Modal, StyleSheet } from "react-native"
import { Button, View } from '../../../src/Components/Themed';
import { FlashHolder } from 'be-components';
import type { LocationProps, MyPlayerProps } from '../../../src/types';

type FlashModalProps = {
    me?:MyPlayerProps,
    mode:'desktop'|'mobile',
    poll_id?:string,
    location?:LocationProps,
    onClose:() => void,
    onRequestLocation:() => void,
    onRequestAuthenticate:() => void
}

const FlashModal = ({ me, mode, onClose, location, onRequestAuthenticate, onRequestLocation, poll_id } : FlashModalProps) => {
    
    return (
        <Modal
            style={styles.modalContainer}
            animationType={mode=='desktop' ? 'fade' : 'slide'}
            transparent
            visible={poll_id ? true : false}
        >
            <View type="blur" style={mode=='desktop' ? styles.desktopContainer : { ...styles.viewContainer}}>
                <View float style={mode=='desktop' ?{ width:500, maxHeight:750, borderRadius:22 }:{ margin:10 }}>
                    {poll_id ?
                    <FlashHolder
                        player={me}
                        style={{ flex:1 }}
                        init_expanded
                        no_highlight
                        location={location}
                        hide_tabs
                        player_id={me?.player_id}
                        poll_id={poll_id}
                        onRequestAuthenticate={onRequestAuthenticate}
                        onRequestLocation={onRequestLocation}
                    />
                    :<></>}
                    <View type='footer' style={{ padding:10 }}>
                        <Button 
                            title='CLOSE'
                            type='close'
                            onPress={() => onClose()}
                        />
                    </View>
                </View>
            </View>

        </Modal>
    )
}

const styles = StyleSheet.create({
    modalContainer: { flex:1 },
    viewContainer: { flex:1, justifyContent:'flex-end' },
    desktopContainer:{ flex:1, justifyContent:'center', alignItems:'center' }
})

export default FlashModal